import { defineStore } from 'pinia'

import { useInstanceCapabilitiesStore } from 'src/stores/instance_capabilities.js'
import { useMergedConfigStore } from 'src/stores/merged_config.js'
import { useUsersStore } from 'src/stores/users.js'

import { fetchScrobbles } from 'src/api/public.js'

const MINUTE = 60 * 1000
// how soon to ask again for someone who scrobbles / who does not
const REFRESH = 10 * MINUTE
const REFRESH_NONE = 60 * MINUTE

export const defaultState = () => ({
  scrobblesNextFetch: new Map(),
})

export const useScrobblesStore = defineStore('scrobbles', {
  state: defaultState,
  actions: {
    // A post shows its author's latest scrobble ("listening to"): one
    // request per author, repeated only after a while.
    getLatestScrobble(userId) {
      const capabilities = useInstanceCapabilitiesStore()
      if (!capabilities.pleromaExtensionsAvailable) return
      if (!capabilities.scrobblesSupport) return
      if (useMergedConfigStore().mergedConfig.hideScrobbles) return
      if (this.scrobblesNextFetch.get(userId) > Date.now()) return

      // no second request while this one runs
      this.scrobblesNextFetch.set(userId, Date.now() + REFRESH_NONE)

      fetchScrobbles({ accountId: userId })
        .then(({ data: scrobbles }) => {
          const user = useUsersStore().findUser(userId)
          if (user) user.latestScrobble = scrobbles[0]
          const wait = scrobbles.length > 0 ? REFRESH : REFRESH_NONE
          this.scrobblesNextFetch.set(userId, Date.now() + wait)
        })
        .catch((e) => {
          // the server has no scrobbles (not Pleroma, or turned off)
          capabilities.set('scrobblesSupport', false)
          console.warn('cannot fetch scrobbles', e)
        })
    },
  },
})
